<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">系统设置</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">号码过滤</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="data-list">
            <a-divider orientation="left">
            线索号码拨打过滤
            </a-divider>
            <p>开启号码过滤，将在坐席拨打号码时对高风险号码进行拦截过滤，降低投诉风险</p>

            <div class="fpstyle" style="margin-top:0">
                <a-radio-group v-model="detail.filtertype" size="large" @change="onChange" >
                    <a-radio value="1">
                    开启
                    </a-radio>

                    

                    <a-radio value="0" style="margin-top:30px">
                    关闭
                    </a-radio>

                </a-radio-group>

               
            </div>


            <a-divider orientation="left" style="margin-top:30px">
            线索号码次数限制
            </a-divider>
            <p>开启号码次数限制，将在坐席拨打号码时对拨打次数进行限制，降低投诉风险</p>
            <div class="fpstyle numlimit" >
                <div>
                    <span>每天拨打次数</span>
                     <a-input-number id="inputNumber" v-model="detail.call_no_day" :min="1"  />
                </div>
                 <div>
                    <span>每月</span>
                     <a-input-number id="inputNumber" v-model="detail.call_no_month" :min="1" />
                </div>

                 <div>
                    <span>总计</span>
                     <a-input-number id="inputNumber" v-model="detail.call_no_all" :min="1"  />
                </div>
            </div>


             <a-divider orientation="left" style="margin-top:30px">
            开启固定号码
            </a-divider>
            <!-- <p>开启固定号码过滤，将在坐席拨打号码时对固定号码进行拦截</p> -->
            <div class="fpstyle" style="margin-top:0">
                <a-radio-group v-model="detail.istel" size="large" @change="onChange" >
                    <a-radio value="0" style="margin-top:30px">
                    关闭（不可以拨打）
                    </a-radio>
                    
                    <a-radio value="1">
                    开启（能拨打）
                    </a-radio>

                    

                  

                </a-radio-group>
            </div>


            <a-button type="primary" @click="tofptype" style="margin-top:20px;display:block">
                确定
            </a-button>
            
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            type:"",
            detail:"",
            daynum:"",
            monthnum:"",
            totalnum:""
        }
    },
    mounted(){
        this.getdetail()
    },
    methods:{
        onChange(e) {
            this.detail.filtertype=e.target.value
        },
        tofptype(){
            this.$axios.post('/api/system/systemset',{
                filtertype:this.detail.filtertype,
                call_no_day:this.detail.call_no_day,
                call_no_month:this.detail.call_no_month,
                call_no_all:this.detail.call_no_all,
                istel:this.detail.istel
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg); 
                    this.getdetail()
                }else{
                    this.$message.warning(res.data.msg); 
                }
                
            })
        },

        getdetail(){
            this.$axios.post('/api/system/systemsetpage',{

            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.detail=res.data.data
                    this.detail.istel=res.data.data.istel.toString()
                }else{
                    this.$message.warning(res.data.msg); 
                }
                
            })
        }
    }

}
</script>


// WEBPACK FOOTER //
// src/components/system/telfilter.vue